import { ref, watch } from '@vue/composition-api'

export default function useAutoSuggest(props) {
  const filteredData = ref({})

  /**
   * Filter group against provided query
   * Grp Structure:
   * {
   *    key: 'title',
   *    data: [
   *      title: 'Admin', img: 'someImage.png',
   *      title: 'Template', img: 'otherImage.png',
   *    ]
   * }
   * @param {Object} grp Group object to perform filter on
   * @param {String} query Query string to filter
   */
  const filterGrp = (grp, query) => {
    const exactEle = grp.kandidati.data.filter(item => item[grp.kandidati.key].toLowerCase().startsWith(query.toLowerCase()))
    const containEle = grp.kandidati.data.filter(
      // prettier-ignore
      item => !item[grp.kandidati.key].toLowerCase().startsWith(query.toLowerCase()) && item[grp.kandidati.key].toLowerCase().indexOf(query.toLowerCase()) > -1,
    )
    return exactEle.concat(containEle).slice(0, props.searchLimit)
  }

  const searchQuery = ref('')
  const resetsearchQuery = () => {
    searchQuery.value = ''
  }

  const handleSearchQueryUpdate = val => {
    if (val === '') {
      filteredData.value = {}
    } else {
      const queriedData = {}
      const dataGrps = Object.keys(JSON.parse(JSON.stringify(props.data.data.value)))
      dataGrps.forEach((grp, i) => {
        queriedData[dataGrps[i]] = filterGrp(JSON.parse(JSON.stringify(props.data.data.value)), val)
      })

      filteredData.value = queriedData
    }
  }

  watch(searchQuery, val => handleSearchQueryUpdate(val))

  return {
    searchQuery,
    resetsearchQuery,
    filteredData,
  }
}
